import { formatFloat } from './formatFloat';
import { debugLogger } from '../debug/DebugLogger';

export const getFormattedFloat = (value: string) => {
  if (value === '') {
    return '';
  }

  const number = Number(value);

  // Number ends with "," - add comma to the end
  if (value.endsWith(',')) {
    const numberWithoutComma = Number(value.replace(',', ''));
    return formatFloat(numberWithoutComma) + ',';
  }

  // Number ends with "." - add comma to the end
  if (value.endsWith('.')) {
    const numberWithoutDot = Number(value.replace('.', ''));
    return formatFloat(numberWithoutDot) + ',';
  }

  // Number contains "," - split the number into whole number part and decimal part
  if (value.includes(',')) {
    const splittedValue = value.split(',');
    const wholeNumberPart = Number(splittedValue[0]);
    const decimalPart = splittedValue[1];
    const formattedWholeNumberPart = formatFloat(wholeNumberPart);
    return formattedWholeNumberPart + ',' + decimalPart;
  }

  if (!isNaN(number)) {
    const dotIndex = value.indexOf('.');
    const fractionDigits = dotIndex >= 0 ? value.length - dotIndex - 1 : 0;
    return formatFloat(number, fractionDigits);
  }

  // Fallback
  /** @debugFeature formatting Logs a value that could not be parsed as a float and fell through to the sanitize fallback. */
  debugLogger.log('formatting', 'invalid float value', () => value);
  // Try to sanitize the value
  return value.replace('.', ',');
};
